require('bootstrap');

const d = $('#offering_date');
d.datetimepicker({
    locale: 'ko',
    format: 'YYYY-MM-DD'
});

function calcSum() {
    const container = document.querySelector('#offering-items');
    if (container) {
        let sum = 0;
        const items = container.querySelectorAll('input[name="amount[]"]');
        items.forEach(el => {
            if (el.value.length > 0) {
                sum += parseInt(removeComma(el.value));
            }
        });

        container.querySelector('#sum').value = parseInt(sum).format();
    }
}

const offeringForm = document.getElementById('offering-form');
if (offeringForm) {
    offeringForm.addEventListener('click', e => {
        let el = e.target;
        if (['svg', 'line'].indexOf(el.nodeName) > -1) {
            while (true) {
                el = el.parentNode;
                if (el.nodeName === 'BUTTON') {
                    break;
                }
            }
        }

        if (el.nodeName === 'BUTTON') {
            if (el.classList.contains('add-offering-row')) {
                const container = offeringForm.querySelector('#offering-items');
                const tpl = container.firstElementChild.cloneNode(true);
                tpl.querySelectorAll('select, input').forEach(elem => {
                    elem.value = '';
                });
                container.insertBefore(tpl, container.querySelector('hr'));
                feather.replace();
                tpl.querySelector('select').focus();

            } else if (el.classList.contains('remove-offering-row')) {
                if (document.querySelectorAll('#offering-items .offering-row').length > 1) {
                    el.closest('.offering-row').remove();
                    calcSum();
                }
            }
        }
    });

    offeringForm.addEventListener('keyup', e => {
        let el = e.target;
        if (el.nodeName === 'INPUT' && el.name === 'amount[]') {

            el.value = el.value.length > 0
                       ? removeComma(el.value).format()
                       : 0;

            calcSum();
        }
    });

    offeringForm.addEventListener('focus', e => {
        let el = e.target;
        if (el.nodeName === 'INPUT' && el.name === 'amount[]') {
            el.value = el.value.length === 0
                       ? 0
                       : el.value;
        }
    });

    offeringForm.addEventListener('submit', e => {
        e.preventDefault();
        const f = e.target;

        f.querySelectorAll('.is-invalid, .invalid-feedback').forEach(el=>{
            if (el.classList.contains('is-invalid')) {
                el.classList.remove('is-invalid');
            } else if (el.classList.contains('invalid-feedback')) {
                el.innerText = '';
            }
        });

        var errors = 0;
        const types = f.querySelectorAll('select[name="type[]"]');
        const amounts = f.querySelectorAll('input[name="amount[]"]');
        types.forEach(el => {
            if (el.value.length === 0) {
                el.classList.add('is-invalid');
                el.nextElementSibling.innerText = '헌금 구분을 선택해주세요.';
                errors++;
            }
        });
        amounts.forEach(el => {
            if (el.value.length === 0) {
                el.classList.add('is-invalid');
                el.nextElementSibling.innerText = '금액을 입력해주세요.';
                errors++;
            }
        });

        if (errors > 0) {
            return false;
        }

        const fd = new FormData(e.target);
        axios.post(e.target.action, fd)
             .then(r => {
                 const result = document.getElementById('offering-request-result');
                 result.style.display = 'block';
                 setTimeout(() => {
                     result.style.display = 'none';
                     e.target.reset();
                 }, 3000);
             })
             .catch(err => {
                 if (err.response && err.response.status === 422) {
                     const errors = err.response.data.errors;
                     const keys = Object.keys(errors);
                     keys.forEach(key => {
                         const val = errors[key][0];
                         const item = f.querySelector(`[name="${key}"]`);
                         item.classList.add('is-invalid');
                         if (item.nextElementSibling.classList.contains('invalid-feedback')) {
                             item.nextElementSibling.innerText = val;
                         }
                     });
                 }
             });
    });
}
